// Librerías de terceros
import React from "react";
import t from "../../utils/translation";

// Estilos e imágenes
import styles from "./Reports.module.css";

// Componentes locales
import PageContainer from "../../components/PageContainer/PageContainer";
import MenuTitleQ from "../../components/MenuQ/MenuTitleQ/MenuTitleQ";
import MenuItemQ from "../../components/MenuQ/MenuItemQ/MenuItemQ";

import MaterialImg from "../../components/NavBar/Menu/icons/INSTRUMENTS.svg";
export default function Reports() {
  return (
    <PageContainer
      categoryId={"REPORTS"}
      category={t("Reports") || "Reports"}
      backUrl={"/appmainQ"}
      progress={true}
    >
      <div className={styles.container}>
        <div className={styles.columnContainer}>
          <div className={styles.column}>
            <MenuTitleQ title={t("MaterialSpan")} image={MaterialImg} />
            <MenuItemQ
              category={"sterilization"}
              title={t("MaterialTracking") || "Material Tracking"}
              url={"/appmaterialtracking"}
              add={false}
            />
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
